export const useRoktPlacementFlag = () => {
  const allowRoktPlacement = useState('allow-rokt-placement', () => false)
  return allowRoktPlacement
}
